import { useLinkBuilder } from '@react-navigation/native'
import { externalLinks } from 'constants'
import React, { useEffect, useMemo, useRef } from 'react'
import { Helmet } from 'react-helmet'

import { generateDynamicLink } from 'utils/links'

export const UpspaceHelmet = ({ navigation }: { navigation: any }) => {
  const navigationState = useMemo(() => (navigation ? navigation.getState() : null), [navigation])

  const appArgument = useRef(externalLinks.DYNAMIC_LINK_PATH)

  const buildLink = useLinkBuilder()

  useEffect(() => {
    if (navigation) {
      generateDynamicLink(
        `${externalLinks.UPSPACE_FULL_PATH}${buildLink(
          navigationState.routes[0].name,
          navigationState.routes[0].params,
        )}`,
      ).then((newDynamicLink) => {
        appArgument.current = newDynamicLink
      })
    }
  }, [buildLink, navigation, navigationState?.routes])

  return (
    <Helmet key={window.location.pathname}>
      <meta
        name='apple-itunes-app'
        content={`app-id=1620955864,app-argument=${appArgument.current}`}
      />
    </Helmet>
  )
}
